import { Injectable } from '@angular/core';
import { ApplicationService } from './application.service';
import { AuthenticationService } from './authentication.service';
import { TemplateService } from './template.service';
import { LookupService } from './lookup.service';
import { DataMappingService } from './data-mapping.service';
import { PracticeService } from './practice.service';

@Injectable({
  providedIn: 'root'
})
export class AppServices {
  constructor(
    public applicationService: ApplicationService,
    public authenticationService: AuthenticationService,
    public templateService: TemplateService,
    public lookupService:LookupService,
    public dataMappingService:DataMappingService,
    public practiceService:PracticeService
  ) {}
}